import { isBooleanTrue, isListNotEmpty, isObjectEmpty, isStringEmpty } from './objectUtils';

// the role flags push reads, as the auth state and a user profile both carry them
export interface PushRoles {
	isRep?: boolean | null;
	isStaffManager?: boolean | null;
	isMarketingManager?: boolean | null;
	isOwner?: boolean | null;
	isAdmin?: boolean | null;
	isSuperAdmin?: boolean | null;
	isHelpStaff?: boolean | null;
}

export type StaffPushTopic = 'allstaff' | 'reps' | 'admins' | 'superadmins' | 'staffmanagers' | 'owners' | 'helpstaff' | 'marketingmanagers' | 'corpstaff';

// the app and admin sites serve one build, so the admin site is known by its host: admin.readyrx.com,
// admin-staging.readyrx.com, and the readyrx-admin and ready-rx-uat*-admin hosting sites
export const isAdminHost = (hostname: string | null | undefined): boolean => {
	if (isStringEmpty(hostname)) {
		return false;
	}

	return (hostname ?? '').toLowerCase().split('.')[0].includes('admin');
};

// the staff audiences a user receives, by role; a user with none is not staff for push
export const getStaffPushTopics = (user: PushRoles | null | undefined): StaffPushTopic[] => {
	if (isObjectEmpty(user)) {
		return [];
	}

	const roles: PushRoles = user ?? {};
	const isSuperAdmin = isBooleanTrue(roles.isSuperAdmin);
	const topics: StaffPushTopic[] = [];
	if (isBooleanTrue(roles.isRep) || isBooleanTrue(roles.isStaffManager) || isBooleanTrue(roles.isMarketingManager) || isBooleanTrue(roles.isOwner) || isBooleanTrue(roles.isAdmin) || isSuperAdmin) {
		topics.push('allstaff');
	}
	if (isBooleanTrue(roles.isRep) || isBooleanTrue(roles.isStaffManager) || isSuperAdmin) {
		topics.push('reps');
	}
	if (isBooleanTrue(roles.isAdmin) || isSuperAdmin) {
		topics.push('admins');
	}
	if (isSuperAdmin) {
		topics.push('superadmins');
	}
	if (isBooleanTrue(roles.isStaffManager) || isSuperAdmin) {
		topics.push('staffmanagers');
	}
	if (isBooleanTrue(roles.isOwner) || isSuperAdmin) {
		topics.push('owners');
	}
	if (isBooleanTrue(roles.isHelpStaff) || isSuperAdmin) {
		topics.push('helpstaff');
	}
	if (isBooleanTrue(roles.isMarketingManager) || isSuperAdmin) {
		topics.push('marketingmanagers');
	}
	if (isBooleanTrue(roles.isMarketingManager) || isBooleanTrue(roles.isAdmin) || isSuperAdmin) {
		topics.push('corpstaff');
	}

	return topics;
};

// push is for staff, on the admin site only - a browser registered on both sites would hold a token for each and
// receive every staff notification twice
export const canRegisterForPush = (user: PushRoles | null | undefined, hostname: string | null | undefined): boolean => (
	isListNotEmpty(getStaffPushTopics(user)) && isAdminHost(hostname)
);
